module.exports = __webpack_public_path__ + "27e2c5b081a749fd15bf358db110172d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-26.png
// module id = 3072
// module chunks = 0